import * as React from "react";
import GotoExchanges from "../../routing/components/redirects/GotoExchanges";
import AccountRoute from "../../accounts/components/pages/AccountRoute";

const ExchangeAccountRoute: React.FC = () => <AccountRoute accountType="exchange" errorComponent={GotoExchanges} />;

export default ExchangeAccountRoute;
